import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
// 批改试卷
import PaperList from '@/pages/paper-list/index'
// 试卷批改-详情页
import PaperInfo from '@/pages/paper-info/index'
// 试卷批改-教师点评
import PaperAssess from '@/pages/paper-assess/index'
// 试卷批改-查看材料
import ViewMaterialPaper from '@/pages/view-paper-material/index'
// 任务认领
import ReceiveTasks from '@/pages/receive-tasks/index'
// 任务详情页
import TaskInfo from '@/pages/task-info/index'
// 批改任务-查看材料
import ViewMaterial from '@/pages/view-material/index'
// 教师点评
import TeacherAssess from '@/pages/teacher-assess/index'
// 批改说明
import CorrectExplain from '@/pages/correct-explain/index'
// 视频预览
import VideoPreView from '@/pages/video-preview/index'
// 作业批改-查看材料
import HomeworkList from '@/pages/homework-list/index'
// 作业批改-详情页
import HomeworkInfo from '@/pages/homework-info/index'
// 作业批改-详情页名称
import HomeworkMain from '@/pages/homework-main/index'
// 作业批改-详情页第一级
import HomeworkFirst from '@/pages/homework-first/index'
// 作业批改-详情页第二级
import HomeworkSecond from '@/pages/homework-second/index'
// 作业批改-详情页第三级
import HomeworkThird from '@/pages/homework-third/index'
// 作业批改-详情页题目
import HomeworkSubject from '@/pages/homework-subject/index'
// 作业批改-右键打开详情页
import HomeworkDetail from '@/pages/homework-detail/index'
// 作业批改-教务跳转
import JwEnter from '@/pages/jw-enter/index'
// 画笔批改
import MarkPaper from '@/pages/mark-paper/index'
// 作业批改-详情页
import HomeworkMock from '@/pages/homework-info/mock'

// 答疑
import AnswerQuestion from '@/pages/answer-question/index'

// 招警机考批改 -- 2021/10/14 潘帅
import JkTaskDistribute from '@/pages/jk-correction-task/distribute'

// 招警-我的批改任务
import MyCorrectionTask from '@/pages/my-correction-task/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '',
          // redirect: '/papercorrection/'
          redirect: '/receive-tasks'
        },
        // 试卷批改
        {
          path: '/papercorrection/*',
          component: PaperList
        },
        // 批改任务认领
        {
          path: '/receive-tasks',
          component: ReceiveTasks
        },
        // 作业批改
        {
          path: '/homeworkcorrection',
          component: HomeworkList
        },
        // 机考人工批改 - 任务分配 2021/10/14
        {
          path: '/jk-task-distribute',
          component: JkTaskDistribute
        },
        // 我的批改任务
        {
          path: '/my-correction-task',
          component: MyCorrectionTask
        }
      ]
    },
    // 画笔批改
    {
      path: '/mark-paper',
      component: MarkPaper
    },
    // 答疑
    {
      path: '/answer-question',
      component: AnswerQuestion
    },
    // 批改任务认领-详情页
    {
      path:'/task-info/:correct_user/:record_id/:job_id/:object_id/:object_type/:orgin/:action_type',
      component: TaskInfo,
    },
    // 批改任务认领-查看材料
    {
      path:'/view-material/:question_id/:question_num',
      component: ViewMaterial,
    },
    // 批改任务认领-教师点评
    {
      path:'/teacher-assess/:correct_user/:job_id/:job_sub_id/:question_id/:question_mode/:question_num/:question_score/:user_answer_sheet_length/:action_type',
      component: TeacherAssess,
    },
    // 批改说明
    {
      path:'/correct-explain',
      component: CorrectExplain,
    },
    // 试卷批改-详情页
    {
      path:'/paper-info/:iip_paper_id/:tiku_paper_id/:record_id/:user_id/:sso_id/:status/:total_score/:score/:objective_score/:exercise_name',
      component: PaperInfo,
    },
    // 试卷批改-查看材料
    {
      path:'/view-paper-material/:question_id/:tiku_paper_id/:record_id/:exercise_name/:question_num',
      component: ViewMaterialPaper,
    },
    // 试卷批改-教师点评
    {
      path: '/paper-assess/:record_id/:user_id/:sso_id/:iip_paper_id/:tiku_paper_id/:question_id/:question_score/:score_mode/:need_score/:cardsNum/:comment_mode/:exercise_name/:question_num',
      component: PaperAssess,
    },
    // 视频预览
    {
        path: '/video-preview/:id',
        component: VideoPreView,
    },
    // 作业批改-详情页-试卷练习册
    {
      path:'/homework-info/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
      component: HomeworkInfo,
      children: [
        {
          path: '/homework-info/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkMain
        },
        {
          path: '/homework-info/main/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkMain
        },
        {
          path: '/homework-info/first/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkFirst
        },
        {
          path: '/homework-info/second/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkSecond
        },
        {
          path: '/homework-info/third/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkThird
        },
        {
          path: '/homework-info/subject/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject/:question_form/:score/:is_new',
          component: HomeworkSubject
        }
      ]
    },
    // 作业批改-详情页-模考
    {
      path:'/homework-mock/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
      component: HomeworkMock,
      children: [
        {
          path: '/homework-mock/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkMain
        },
        {
          path: '/homework-mock/main/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkMain
        },
        {
          path: '/homework-mock/first/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkFirst
        },
        {
          path: '/homework-mock/second/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkSecond
        },
        {
          path: '/homework-mock/third/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject',
          component: HomeworkThird
        },
        {
          path: '/homework-mock/subject/:object_id/:record_id/:tiku_user_id/:object_type/:exercise_id/:correct_user/:sso_id/:level_no/:comment_object_id/:comment_type/:is_release/:is_reject/:question_form/:score/:is_new',
          component: HomeworkSubject
        }
      ]
    },
    // 右键详情
    {
      path: '/homework-detail/:object_id/:record_id/:object_type/:sso_id/:question_id/:text_type',
      component: HomeworkDetail,
    },
    // 教务跳转批改
    {
      path: '/jw-enter/:paper_id/:practice_id/:phone/:correct_user/:record_id/:exercise_id/:object_type',
      component: JwEnter,
    },
    {
      path: '/jw-mock/:exercise_id/:mock_id/:paper_id/:sso_id/:correct_user/:record_id',
      component: JwEnter,
    },
    { path:'*',redirect:'/'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js